import type { FC } from 'react';
import { DrawerSection } from '@components/DrawerSection';

import { BrandingImagesListing } from './BrandingImagesListing';

interface BrandingDetailsDrawerProps {}

export const BrandingDetailsDrawer: FC<BrandingDetailsDrawerProps> = () => {
  return (
    <div className="max-w-drawer flex h-full w-1/3 flex-col border-l bg-white px-3 py-6">
      <DrawerSection title={'Image library'} className="mt-20">
        <BrandingImagesListing />
      </DrawerSection>
    </div>
  );
};
